import * as React from 'react'
import { Margin } from 'web-makeup/dist/design-system/styles/spacings'
import { Text } from 'web-makeup/dist/design-system/styles/typography'
import CloudinaryImage from 'web-makeup/dist/CloudinaryImage'
import * as moment from 'moment'
import ReactTooltip from 'react-tooltip'
import { sum, map } from 'lodash'

import EnvironmentContext from '../../../EnvironmentContext'

import { numberWithCommas } from '../../../../helpers/priceFormater'
import { trimText } from '../../../../components/SelectBrands/helpers/project-helpers'

import {
  Container,
  Header,
  ProjectTitle,
  Date,
  Amount,
  AmountFlex,
  SmallText,
  Price,
  AmountBar,
  Includes,
  ProjectsWrapper,
  ProjectsButtton,
  ProjectsList,
  ProjectItem,
  Cost,
  ReactToolTipStyles,
  AmountWrapper,
} from './BrandWalletCard.style'

export interface BrandWalletCardProps {
  project?: any
  completed?: boolean
}

const BrandWalletCard: React.FC<BrandWalletCardProps> = ({ project, completed }) => {
  const [showProjects, setShowProjects] = React.useState(false)
  const {
    name,
    price: walletPrice,
    customerContract,
    uuid,
    dueDate,
    jobs: walletJobs,
    state,
    orderSource,
  } = project || ''
  const { amount, currency } = walletPrice || ''
  const { projects: customerProjects, signedAt, invoices: walletInvoices } = customerContract || ''
  const { GEN1_BASE_URL, ORDER_SUMMARY_URL } = React.useContext(EnvironmentContext) || ''
  const walletInvoicesAmount = sum(map(map(walletInvoices, 'price'), 'amount'))
  const amountPercentage = ((walletInvoicesAmount - amount) / walletInvoicesAmount) * 100

  const bonusNames = ['Bonus Credit', 'Bonus Credits']

  const jobsDatesArray =
    walletJobs &&
    walletJobs.map(job => {
      return job.dueDate
    })
  const completedOn =
    jobsDatesArray && jobsDatesArray.length > 0 && jobsDatesArray.reduce((a, b) => (a > b ? a : b))
  const projectDate = moment(state === 'COMPLETED' ? completedOn : dueDate).format('MMM DD, YYYY')

  const bonusCreditJob =
    walletJobs &&
    walletJobs.filter(job => {
      return bonusNames.some(v => job.name === v)
    })

  const totalBonusCredit = sum(map(map(bonusCreditJob, 'totalPrice'), 'amount'))
  const projectLink =
    orderSource === 'order'
      ? ORDER_SUMMARY_URL && `${ORDER_SUMMARY_URL}/orders/${uuid}`
      : GEN1_BASE_URL && `${GEN1_BASE_URL}/video_projects/${uuid}`
  return (
    <div>
      <ReactToolTipStyles />
      <Container>
        <Header>
          <ProjectTitle href={projectLink}>{trimText(name, 100)}</ProjectTitle>
          <div>
            <Date>
              Signed: <strong>{signedAt ? moment(signedAt).format('MMM DD, YYYY') : '- -'}</strong>
            </Date>
            <Date isProjectCompleted={completed}>
              {completed ? `Completed:` : `Expires:`} <strong>{projectDate}</strong>
            </Date>
          </div>
        </Header>
        <Amount>
          <AmountFlex centered={amountPercentage === 100 || completed}>
            <div>
              <SmallText>AMOUNT</SmallText>
              <Price>
                <span>{currency && currency.code}</span> {currency && currency.symbol}
                {(walletInvoicesAmount && numberWithCommas(walletInvoicesAmount)) || 0}
              </Price>
            </div>
            {!completed &&
              amountPercentage !== 100 && (
                <div>
                  <SmallText>REMAINING*</SmallText>
                  <Price>
                    <span>{currency && currency.code}</span> {currency && currency.symbol}
                    {amount && numberWithCommas(amount)}
                  </Price>
                </div>
              )}
          </AmountFlex>

          <AmountWrapper>
            <AmountBar progress={completed ? 100 : amountPercentage} />
            {bonusCreditJob &&
              bonusCreditJob.length > 0 && (
                <Includes>
                  *INCLUDES BONUS CREDIT: USD{' '}
                  <strong>
                    {totalBonusCredit &&
                      `${bonusCreditJob[0].totalPrice.currency.symbol}${numberWithCommas(
                        totalBonusCredit
                      )}`}
                  </strong>
                  <span data-tip="Bonus credit can only be used once the full amount of the wallet has been used up.">
                    <CloudinaryImage
                      useSourceFormat
                      source={{
                        id: 'v1633353797/-design-system/icon-tooltip.svg',
                        type: 'upload',
                      }}
                    />
                  </span>
                </Includes>
              )}
            <ReactTooltip place="bottom" type="dark" effect="solid" />
          </AmountWrapper>
        </Amount>
        {customerProjects &&
          customerProjects.length && (
            <ProjectsWrapper>
              <Text as="div" fontSize="h5" color="black1" fontWeight="black" textAlign="center">
                {customerProjects && customerProjects.length} projects
              </Text>
              <Margin bottom size="small" />
              {showProjects && (
                <ProjectsList>
                  {customerProjects.map((item, index) => (
                    <ProjectItem
                      key={index}
                      onClick={() =>
                        orderSource === 'order'
                          ? ORDER_SUMMARY_URL &&
                            (window.location.href = `${ORDER_SUMMARY_URL}/orders/${uuid}`)
                          : GEN1_BASE_URL &&
                            (window.location.href = `${GEN1_BASE_URL}/video_projects/${uuid}`)
                      }
                    >
                      <div>
                        <Text
                          as="div"
                          fontSize="h3"
                          color="black1"
                          fontWeight="black"
                          lineHeight="big"
                        >
                          {item.name}
                        </Text>
                        <Text as="div" fontSize="h5" color="black1" lineHeight="big">
                          Due: <strong>{moment(item.dueDate).format('MMM DD, YYYY')}</strong>
                        </Text>
                      </div>
                      <Cost>
                        <Text as="span" fontSize="h3" color="black1">
                          {item.price && item.price.currency.code}
                        </Text>
                        {` `}
                        <Text as="span" fontSize="h1" color="black1" fontWeight="black">
                          {item.price && item.price.currency.symbol}
                          {item.price && item.price.amount}
                        </Text>
                        <CloudinaryImage
                          useSourceFormat
                          source={{
                            id: 'v1609420028/Engineering/icon-direct.svg',
                            type: 'upload',
                          }}
                        />
                      </Cost>
                    </ProjectItem>
                  ))}
                </ProjectsList>
              )}
              <ProjectsButtton
                onClick={() => setShowProjects(!showProjects)}
                isActive={showProjects}
              >
                {showProjects ? `Hide scheduled & complete` : `View scheduled & complete`}
              </ProjectsButtton>
            </ProjectsWrapper>
          )}
      </Container>
    </div>
  )
}

export default BrandWalletCard



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/BrandWalletCard/BrandWalletCard.tsx